import { FilterList } from '@mui/icons-material';
import { Box, Toolbar, Typography } from '@mui/material';
import { TableInstance } from 'react-table';
import { useMenu } from 'shared/hooks';
import ActionButton from './action-button';
import FilterPage from './filter-page';

type TableToolBarProps<T extends object> = {
    instance: TableInstance<T>;
};
export default function TableToolBar<T extends object>({ instance }: TableToolBarProps<T>) {
    const [anchorEl, handleFilterClick, handleClose, filterOpen] = useMenu();
    const { editAction, exportAction, searchAction, showAllAction, totalCount, renderEdit } = instance;
    return (
        <Toolbar sx={{ display: 'grid', gridTemplateColumns: '1fr .5fr 1fr' }}>
            <Box display='grid' gridTemplateColumns='.25fr .25fr'>
                <Box marginRight={3}>
                    {renderEdit && renderEdit(instance)}
                    {editAction && editAction(instance)}
                </Box>
                {showAllAction && showAllAction(instance)}
            </Box>
            <Typography textAlign='center'>
                <strong>{totalCount} Products in View</strong>
            </Typography>
            <Box display='grid' gridTemplateColumns='1fr .25fr'>
                <Box display='flex' justifyContent='center'>
                    {searchAction && searchAction(instance)}
                </Box>
                <div>
                    <FilterPage instance={instance} onClose={handleClose} show={filterOpen} anchorEl={anchorEl} />
                    <ActionButton icon={<FilterList />} onClick={handleFilterClick} label='Filters' />
                    {exportAction && exportAction(instance)}
                </div>
            </Box>
        </Toolbar>
    );
}
